module.exports = __webpack_public_path__ + "static/img/android.6ac3d5bb.png";